/*
    模块组件
    ChenYN

    说明
    顶部小icon

    版本
    1.0

    传参
        type Sring : 非必填 类型 default = '默认白色的图标'; grey = 灰色的图标
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <HeadIcon></HeadIcon>
*/

<template>
    <div class="head_icons">
        <Icon v-for="v in list" size="24px" :key="v.name" :name="v.url" class="icons" @click="iconHandle(v.name)" />
        <div class="dot_bg" v-if="unreadMsg > 0">{{unreadMsg > 99 ? '99+' : unreadMsg}}</div>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, computed, onActivated } from 'vue';
import { Icon  } from "vant"
import router from "@/router"
import store from "@/store"
import Util from '@/assets/js/lib/util';

import msg from "@/assets/images/atmosphere/icon_msg.png"
import kefu from "@/assets/images/atmosphere/icon_kefu.png"
import search from "@/assets/images/atmosphere/icon_search.png"

import msgGrey from "@/assets/images/head/icon_msg_grey.png"
import kefuGrey from "@/assets/images/head/icon_kefu_grey.png"
import searchGrey from "@/assets/images/head/icon_search_grey.png"

export default defineComponent({
    name: 'HeadIcon',
    components: { Icon },
    props: {
        type: {
            type: String,
            default: 'default'
        },
        miniapp:{
          type: String,
          default: 'default'
        }
    },
    setup(props) {
        const state = reactive({
            util: new Util(),
            list: [
                {
                    txt: '这个是信息按钮',
                    name: 'message',
                    url: props.type == 'grey' ? msgGrey : msg,
                    dot: false
                },
                // {
                //     txt: '这个是客服按钮',
                //     name: 'customercenter',
                //     url:  props.type == 'grey' ? kefuGrey : kefu,
                //     dot: false
                // },
                // {
                //     txt: '这个是搜索按钮',
                //     name: 'search',
                //     url:  props.type == 'grey' ? searchGrey : search,
                //     dot: false
                // },
            ],
            userInfo: computed(() => store.state.userInfo),
            unreadMsg: 0,
            official_count: 0,
        });

        const methods = {
            back: () => router.back(),
            goState: o => router.push(o),
            iconHandle: (name) => {
                switch (name) {
                    case 'search':
                        let path = router.currentRoute.value.name;
                        methods.goState({name: name, params: {type: path == 'welfare' ? 'welfare' : 'ordinary' }})
                        break;

                    default:
                        methods.goState({name: name})
                        break;
                }
            },
        }

        onMounted(async() => {
            if(props.miniapp){
              state.list = [
              {
                    txt: '这个是信息按钮',
                    name: 'message',
                    url: props.type == 'grey' ? msgGrey : msg,
                    dot: false
                },
                // {
                //     txt: '这个是搜索按钮',
                //     name: 'search',
                //     url:  props.type == 'grey' ? searchGrey : search,
                //     dot: false
                // },
              ]
            }
            if(state.userInfo && JSON.stringify(state.userInfo) == '{}'){
                setTimeout(() => {
                    initDot();
                }, 200);
            }else{
                initDot();
            }
            await reqList()
            await reqUnread();
        });

        onActivated(async () => {
            setTimeout(() => {
                initDot();
            }, 300);
            await reqList()
            await reqUnread();
        })

        const reqList = async (flag = false) => {// 请求数据列表

            const res = await state.util.getJson("/message/official", "GET", {
                page: 1,
                per_page: 30
            }, true);

            if(res.code == 0) {

                // if(flag){ //加载更多
                //     data.official.push(...res.data.list);
                // }else{ //刷新
                //     if(res.data.list){
                //         data.official = [...res.data.list];
                //     }else{
                //         data.official = [];
                //     }
                // }

                // state.page += 1;
                // if(res.data.total > 1){
                //     state.total = res.data.total;
                // };
            }else{
                window.Components.toast(res.msg)
            }
        };

        const reqUnread = async (flag = false) => {// 请求数据列表
            const res2 = await state.util.getJson("/message/unreadOfficial", "GET", {}, true);
            let official_count = 0;
            if(res2.code == 0) {
                if(res2.data){
                    res2.data.map(item => {
                        official_count = official_count + item.unread;
                    })
                    state.official_count = official_count;
                }
            }else{
                // window.Components.toast(res.msg)
            }

            //避免因为后面接口返回为null情况下导致未读消息无法赋值；在有官方未读消息但没有点赞或回复消息的情况下，会显示为0
            state.unreadMsg = official_count;

            const res = await state.util.getJson("/message/unread", "GET", {}, true);
            if(res.code == 0) {
                if(res.data){
                    state.unreadMsg = res.data.invite_count + res.data.like_count + res.data.reply_count + state.official_count
                }
            }else{
                window.Components.toast(res.msg)
            }
        };

        const initDot = () => {
            state.list[0].dot = state.userInfo.official_count > 0 || state.userInfo.invite_count > 0 || state.userInfo.like_count > 0 || state.userInfo.reply_count > 0;
        };

        return {
            ...toRefs(state),
            ...methods,
        };
    },
});
</script>
<style lang="less" scoped>
@import "./HeadIcon.less";
</style>
